import React from "react";
import Typography from "@material-ui/core/Typography";
const Usage = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Usage
      </Typography>
      <Typography paragraph variant="h5">
        Get started with Invifo platform in no time.
      </Typography>
      <Typography paragraph variant="body1">
        The Invifo platform UI is divided into 6 areas which are very easy to
        use and easy to understand: Header, Footer, Sidebar, Navbar, Ribbon, and
        Content.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Header</strong> : This is the area where you can find various
        menus and extended features like Dashboard, Main Menu, Search Bar,
        Notification, Language Setting, Preferences UI Themes, and User Profile.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Footer</strong> : This is the area where you can find the
        server's current timezone and any information about the Invifo company
        like Legal Statement, About Us, and Contact.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Sidebar</strong> : This is the area where you can find various
        reports or modules to do the transactions from end-to-end of the
        business process. The modules consist of CRM, Sales, Inventory,
        Procurement, Finance, User, Setup, and many more awesome features that
        will be added continuously.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Navbar</strong> : This is the area where you can find the main
        navigation of the accessed feature and some main buttons to navigate to
        the previous screen or to create and save the transaction.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Ribbon</strong> : This is the area where you can find Online
        Help and Guidance on how to use and understand the platform.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Content</strong> : This is the area where you can perform the
        transactions and see the list of valuable information.
      </Typography>
    </React.Fragment>
  );
};

export default Usage;
